import ScenePage3 from './ScenePage3';

export default ScenePage3;
